// extracted by mini-css-extract-plugin
module.exports = {"SimplePlayer":"_38O7E","simplePlayer":"_38O7E","mediaButton":"hmaYO","icon":"_2E5oa","pausing":"_2w-yo","playing":"ldPDa"};